"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const lodash_1 = require("lodash");
const common_1 = require("@Const/common");
class Input extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "inputValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.value || ''
        });
        Object.defineProperty(this, "activeInputState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onFocusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.activeInputState = true)
        });
        Object.defineProperty(this, "onBlurInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.activeInputState = false)
        });
        Object.defineProperty(this, "handleChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.inputValue = event.target.value;
                this.onSave();
            }
        });
        Object.defineProperty(this, "cleanChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.inputValue = '';
                this.onSave();
            }
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, lodash_1.debounce)(() => {
                this.props.onChange(this.inputValue, this.props.id);
            }, 200)
        });
        (0, mobx_1.makeObservable)(this, {
            inputValue: mobx_1.observable,
            activeInputState: mobx_1.observable,
            onFocusInput: mobx_1.action,
            onBlurInput: mobx_1.action,
            handleChange: mobx_1.action,
            cleanChange: mobx_1.action,
        });
    }
    componentDidUpdate() {
        if (this.props.clear) {
            this.cleanChange();
        }
    }
    render() {
        const { mainColor, id, type, errorMessage, title, disabled, helperText } = this.props;
        const classNames = [
            'input-component',
            mainColor ? 'main-color-set' : 'second-color-set',
            type,
            this.activeInputState ? 'focused' : '',
            this.inputValue ? 'filled' : '',
            errorMessage ? 'error' : '',
        ].join(' ');
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("p", { className: "small-2 medium", title: title }, title),
            react_1.default.createElement("div", { className: "input-wrapper" },
                react_1.default.createElement("input", { type: "text", id: id, value: this.inputValue, onBlur: this.onBlurInput, onFocus: this.onFocusInput, onChange: this.handleChange, disabled: !!disabled, placeholder: !this.activeInputState ? title : '', onKeyPress: this.props.onKeyPress }),
                this.inputValue && (react_1.default.createElement("img", { onClick: this.cleanChange, className: 'remove-value', src: common_1.ICONS.close, alt: "close" }))),
            errorMessage ? (react_1.default.createElement("p", { className: "error-text small" }, errorMessage)) : helperText ? (react_1.default.createElement("p", { className: "basic-input-helper-text small" }, helperText)) : null));
    }
}
exports.default = (0, mobx_react_1.observer)(Input);
